import { BaseApi } from './base.api.js';

export class VendorAssessmentApi extends BaseApi {
    constructor(client) {
        super(client, '/vendor-assessment');
    }
}
